const motions = new Map();
const lastTargets = new WeakMap();
let frame = null;
let lastTime = null;

function animate(time) {
  frame = null;
  const elapsed = lastTime == null ? 16.67 : Math.min(64, time - lastTime);
  lastTime = time;
  const blend = 1 - Math.exp(-elapsed / 240);
  for (const [element, motion] of motions) {
    if (!element.isConnected) {
      motions.delete(element);
      continue;
    }
    motion.current += (motion.target - motion.current) * blend;
    const settled = Math.abs(motion.target - motion.current) < 0.1;
    if (settled) motion.current = motion.target;
    element.style.translate = `0 ${motion.current}px`;
    if (settled) motions.delete(element);
  }
  if (motions.size) frame = requestAnimationFrame(animate);
  else lastTime = null;
}

export function setParallaxTranslation(element, offset, desktop, disabled = false) {
  if (desktop || disabled) {
    motions.delete(element);
    lastTargets.delete(element);
    element.style.translate = disabled ? '0 0' : `${offset}px 0`;
    return;
  }
  const requestedTarget = Math.max(-32, Math.min(32, offset * 0.4));
  const previousTarget = lastTargets.get(element);
  const target = previousTarget != null && Math.abs(requestedTarget - previousTarget) < 0.5
    ? previousTarget : requestedTarget;
  lastTargets.set(element, target);
  let motion = motions.get(element);
  if (motion) {
    if (Math.abs(target - motion.target) >= 0.5) motion.target = target;
  }
  else {
    const previous = element.style.translate.trim().split(/\s+/);
    const current = previous.length > 1 ? Number.parseFloat(previous[1]) || 0 : 0;
    motion = { current, target };
    motions.set(element, motion);
  }
  if (frame == null) frame = requestAnimationFrame(animate);
}